<script lang="ts" setup>
import { computed, onMounted, PropType, ref } from "vue";
import { EditQueueModalChooseUsers } from "./";
import { EditQueueAdapterService } from "../../adapter-service";
import { QueueTasksModel } from "@/components/sidebar/models";
import { EmployeeAccessModel, EmployeeModel } from "../../models";
import { EmployeeQueueAccessEnum } from "../../enums";
import { TaskParametersLeave } from "@/components/task-parameters-form/components";
import UpdateQueueTaskEmployeeRoleAccessListUserItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/queue-task/request/UpdateQueueTaskEmployeeRoleAccessListUserItem";
import { mapUpdateUsersAccessResponse } from "../../adapter-service/adapter-service.mappers";

/**API сервис */
const apiService = new EditQueueAdapterService();

/**Параметры */
const props = defineProps({
  /**Id редактируемой очереди */
  queue: { type: Object as PropType<QueueTasksModel> },
});

/**Все сотрудники */
const allUsers = ref<EmployeeModel[]>([]);
/**Все сотрудники с доступом к очереди */
const queueUsers = ref<EmployeeModel[]>([]);
const queueAccessUsers = ref<EmployeeAccessModel[]>([]);
const queueDeletedUsers = ref<EmployeeModel[]>([]);

/**События */
const emit = defineEmits<{
  /**Закрыть окно */
  (e: "onClose"): void;
}>();
/**После рендера */
onMounted(async () => {
  await getqueueUsers();
  await getEmployees();
  await getqueueAccessUsers();
  await getDeletedAccessUsers();
});

/**Получение сотрудников */
const getqueueUsers = async () => {
  const response = await apiService.getQueueTaskEmployeeList(props.queue.Id);
  if (response.IsSuccess) {
    queueUsers.value = response.Value;
  }
};
/**Получение сотрудников */
const getqueueAccessUsers = async () => {
  const response = await apiService.getUsersWorkSpaceAsync({ QueueTaskId: props.queue.Id });
  if (response.IsSuccess) {
    queueAccessUsers.value = response.Value;
  }
};
/**Получение сотрудников */
const getDeletedAccessUsers = async () => {
  const response = await apiService.getDeletedUsersWorkSpaceAsync({ QueueTaskId: props.queue.Id });
  if (response.IsSuccess) {
    queueDeletedUsers.value = response.Value;
  }
};
/**Получить пользователей */
const getEmployees = async () => {
  const response = await apiService.getUsers();
  if (response.IsSuccess) {
    allUsers.value = response.Value;
  }
};

/**Обновить список пользователей с доступом к очереди */
const updateUsers = async () => {
  const queueUsersIds = queueUsers.value.map((x) => x.Id);
  apiService.updateQueueTaskEmployeeRoleList(props.queue.Id, queueUsersIds);
};
/**Обновить доступы к очереди */
const updateAccesses = async () => {
  await apiService.updateQueueTaskEmployeeRoleAccessList(props.queue.Id, queueUsers.value);
};
const $taskParametersLeave1 = ref<InstanceType<typeof TaskParametersLeave>>();
// const access= queueUsers
/**Открыть окно с подтверждением выхода из настройки */
const openLeaveConfirmation = (callback?: Function) => {
  $taskParametersLeave1.value?.toggle(true, callback);
};

/**данные поменялись */
const haveChanges = ref(false);

function onChange(value: boolean = true) {
  haveChanges.value = value;
}
async function saveUsersAccess() {
  const req = new UpdateQueueTaskEmployeeRoleAccessListUserItem();
  await apiService.saveUsersAcessAsync({
    QueueTaskId: props.queue.Id,
    Users: mapUpdateUsersAccessResponse(queueAccessUsers.value),
  });
  haveChanges.value = false;
}
function onClose() {
  emit("onClose");
}
/**Код для использования по ref */
defineExpose({
  haveChanges,
  openLeaveConfirmation,
});
</script>
<template>
  <div class="edit-queue-modal-employees">
    <EditQueueModalChooseUsers
      title="Все сотрудники"
      :allUsers="allUsers"
      :queue="queue"
      :queueUsers="queueAccessUsers"
      :queueDeletedUsers="queueDeletedUsers"
      @onChange="onChange"
      @onClose="onClose"
      @onSave="saveUsersAccess"
    />
  </div>
  <TaskParametersLeave ref="$taskParametersLeave1" />
</template>
<style lang="scss" scoped>
.edit-queue-modal-employees {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>
